export default "__VITE_ASSET__DQG8b015__"